import LocaleService from 'services/locale-service';
import LearnerProfileService from 'services/learner-profile-service';
import URLSearchParams from 'url-search-params'

class HtmlImportService {
  getHtml({ path, url }) {
    if (!path) return Promise.reject('No Path provided')
    const finalUrl = this.parsePath({ path, url });
    return fetch(finalUrl).then(data => data.text());
  }
  parsePath({ path, url }) {
    let finalUrl = url;
    if (path && !finalUrl) {
      finalUrl = `https://s3.amazonaws.com/everfi-curriculums/content/{{version}}/${path}`;
    }

    const params = new URLSearchParams(window.location.search);

    if (params && params.get('html_import_version')) {
      finalUrl = finalUrl.replace(/{{version}}/, params.get('html_import_version'));
    } else if (EF.options.local) {
      finalUrl = finalUrl.replace(/{{version}}/, 'develop');
    } else {
      finalUrl = finalUrl.replace(/{{version}}/, 'master');
    }
    finalUrl = finalUrl.replace(/{{language}}/, LocaleService.getLanguage());

    const isoCode = LearnerProfileService.get('learner_location_iso_code');
    if (isoCode && isoCode.includes('-')) {
      const [country, region] = isoCode.split('-');
      if (country) {
        finalUrl = finalUrl.replace(/{{country}}/, country.toLowerCase());
      }
      if (region) {
        finalUrl = finalUrl.replace(/{{region}}/, region.toLowerCase());
      }
    }
    return finalUrl;
  }
}

export default new HtmlImportService();